module.exports = __webpack_public_path__ + "media/club_product_v2/2-226297f7.webp";